<template>
  <div>
    <h3 class="font-medium text-m1 mb-16">Ratings & reviews</h3>
    <ratings-overview :count="totalReviewCount" :average="starAggregate" :distribution-data="ratingsDistribution" />
    <reviews-list :reviews="reviews" :total-review-count="totalReviewCount" class="mt-16" @view-more-reviews="viewMoreHandler" />
  </div>
</template>

<script lang="ts">
import RatingsOverview from '@/components/ratings_overview/RatingsOverview.vue';
import ReviewsList from '@/components/reviews_list/ReviewsList.vue';

interface DistributionData {
  count: number;
  percent: number;
  stars: number;
}

export default {
  name: 'RatingsAndReviews',
  components: {
    RatingsOverview,
    ReviewsList,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
  },
  computed: {
    reviews(): any {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.edges || [];
    },
    starAggregate(): number {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.starAggregate || 0;
    },
    totalReviewCount(): number {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.totalReviewCount || 0;
    },
    ratingsDistribution(): Array<DistributionData> {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.ratingsDistribution || [];
    },
  },
  methods: {
    viewMoreHandler(): void {
      this.$emit('update:modelValue', this.modelValue + 3);
    },
  },
};
</script>
